import { render, staticRenderFns } from "./AssetVideoUploadInfo.vue?vue&type=template&id=3e01c72f&lang=pug"
import script from "./AssetVideoUploadInfo.vue?vue&type=script&lang=js"
export * from "./AssetVideoUploadInfo.vue?vue&type=script&lang=js"
import style0 from "./AssetVideoUploadInfo.vue?vue&type=style&index=0&id=3e01c72f&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports